import {Component, OnInit, Injector} from '@angular/core';
import {FilterValue} from "../../../../../services/model/filterValue";
import {EfastFilterBaseComponent} from "../efast-filter-base.component";

@Component({
    selector: 'efast-filter-plan-year',
    templateUrl: 'efast-filter-plan-year.component.html',
    styleUrls: ['efast-filter-plan-year.component.css'],
    standalone: false
})

export class EfastFilterPlanYearComponent extends EfastFilterBaseComponent implements OnInit {

    constructor(protected injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.title= this.cacheService.getLabelFromResource('FILTER:FILTERPlanYearTitle');

        let filterValues: FilterValue[] = new Array();

        this.filterCategory.filterType = this.staticsService.getFilterType().PLAN_YEARS;

        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERPlanYearLbl26'),
            this.staticsService.getPlanYearFilter().YEAR_26));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERPlanYearLbl25'),
            this.staticsService.getPlanYearFilter().YEAR_25));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERPlanYearLbl24'),
            this.staticsService.getPlanYearFilter().YEAR_24));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERPlanYearLbl23'),
            this.staticsService.getPlanYearFilter().YEAR_23));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERPlanYearLbl22'),
            this.staticsService.getPlanYearFilter().YEAR_22));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERPlanYearLbl21'),
            this.staticsService.getPlanYearFilter().YEAR_21));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERPlanYearLbl20'),
            this.staticsService.getPlanYearFilter().YEAR_20));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERPlanYearLbl19'),
            this.staticsService.getPlanYearFilter().YEAR_19));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERPlanYearLbl18'),
            this.staticsService.getPlanYearFilter().YEAR_18));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERPlanYearLbl17'),
            this.staticsService.getPlanYearFilter().YEAR_17));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERPlanYearLbl16'),
            this.staticsService.getPlanYearFilter().YEAR_16));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERPlanYearLbl15'),
            this.staticsService.getPlanYearFilter().YEAR_15));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERPlanYearLbl14'),
            this.staticsService.getPlanYearFilter().YEAR_14));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERPlanYearLbl13'),
            this.staticsService.getPlanYearFilter().YEAR_13));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERPlanYearLbl12'),
            this.staticsService.getPlanYearFilter().YEAR_12));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERPlanYearLbl11'),
            this.staticsService.getPlanYearFilter().YEAR_11));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERPlanYearLbl10'),
            this.staticsService.getPlanYearFilter().YEAR_10));
        filterValues.push(this.addFilterValue(
            this.cacheService.getLabelFromResource('FILTER:FILTERPlanYearLbl09'),
            this.staticsService.getPlanYearFilter().YEAR_09));
        this.filterCategory.filterValues = filterValues;

        super.ngOnInit();
    }

    protected expandClick() {
        super.expandClick();
    }

    //extended
    protected searchChangeEvent() {
        this.setBucket(this.applicationService.getAfsForm().facets.planyear.buckets);
        super.searchChangeEvent();
    }

    //extended
    protected rowClick(filterValue: FilterValue) {
        super.rowClick(filterValue);
        this.queryManagerService.addQueryValueNoSearch(this.staticsService.getCategoryType().PLAN_YEAR, this.queryValue, true)
    }

}